export const Constants = {
    GlobalGiftVoucherHostSiteId: 16
} as const;
